import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SupersGuard implements CanActivate {

  constructor(private router: Router, private localStorageService: LocalStorageService) {}

  canActivate(): boolean {
    const profile = this.localStorageService.get('profile');
    if (profile === 'Supervisor') {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
